import { render, staticRenderFns } from "./SchoolFinder.vue?vue&type=template&id=32a6dd03&scoped=true&"
import script from "./SchoolFinder.vue?vue&type=script&lang=js&"
export * from "./SchoolFinder.vue?vue&type=script&lang=js&"
import style0 from "./SchoolFinder.vue?vue&type=style&index=0&id=32a6dd03&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a6dd03",
  null
  
)

export default component.exports